<template>
  <div class="digital-twin">
    <div class="solution-banner">
      <img src="@/assets/images/website/solution/digital-twin/banner.png" />
    </div>
    <div class="digital-twin-introduce">
      <div class="website-container">
        <img alt src="@/assets/images/website/solution/digital-twin/part_1.png" />
        <img alt src="@/assets/images/website/solution/digital-twin/part_2.png" />
        <img alt src="@/assets/images/website/solution/digital-twin/part_3.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="less" scoped>
.solution-banner {
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
  }
}
.digital-twin-introduce {
  img {
    width: 100%;
    margin: 20px 0;
  }
}
</style>
